import { useOcctoRequestFacility, useOpenRequestFacility } from '@hooks/Services';
import { Error } from '@organisms/Feedbacks';
import { Container } from '@organisms/GenesisEs/Layouts';
import { DetailFacilityInfo } from '@organisms/GenesisEs/List';
import { TitleWithUpdateButton } from '@organisms/GenesisEs/Utils';
import React, { useState } from 'react';


type Props = {
    powerCustomerLocationNumber: string;
};

const defaultUpdateTime:number = new Date().getTime();

const ContainerForFacility = (props: Props) => {
    const { powerCustomerLocationNumber } = props;
    const [updateTime, setUpdateTime] = useState(defaultUpdateTime);
    const listData = updateTime === defaultUpdateTime ?
        useOpenRequestFacility.useAllListData(powerCustomerLocationNumber, updateTime)
    :
        useOcctoRequestFacility.useAllListData(powerCustomerLocationNumber, updateTime)
    ;
    const { data } = listData;
    
    const lastUpdateTime = data?.lastUpdateDate || '';
    // const lastUpdateTime = dateFormatFromTimestamp(data?.saishuKoshinTimestamp) || '';

    const updateListHandlar = (updateTime:number) => {
        setUpdateTime(updateTime);
    };
    const children = powerCustomerLocationNumber === '' ? <Error/> : <DetailFacilityInfo listData={listData} />;

    return (
        <>
            <Container
                title={
                    <TitleWithUpdateButton
                        title='設備情報'
                        callback={updateListHandlar}
                        facilityUpdateTime={lastUpdateTime}
                    />
                }
                children={children}
            />
        </>
    );
};


export default ContainerForFacility;
